import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';

export const GET_TIME_ENTRY_REVISION_GROUP_BULK_MODIFICATION_BATCH_RESULTS = gql`
  query getTimeEntryRevisionGroupBulkModificationBatchResults(
    $batchId: String!
  ) {
    getTimeEntryRevisionGroupBulkModificationBatchResults(batchId: $batchId) {
      modified
      errors {
        timeEntryRevisionGroupId
      }
    }
  }
`;

export const useMoveTimeBatchResults = ({ batchId } = {}) => {
  const { data, refetch } = useQuery(
    GET_TIME_ENTRY_REVISION_GROUP_BULK_MODIFICATION_BATCH_RESULTS,
    {
      variables: { batchId },
      skip: !batchId,
      fetchPolicy: 'network-only'
    }
  );

  const batchResults =
    data?.getTimeEntryRevisionGroupBulkModificationBatchResults || null;

  return {
    successCount: batchResults?.modified?.length,
    errorCount: batchResults?.errors?.length,
    refetch
  };
};

export default useMoveTimeBatchResults;
